module.exports = __webpack_public_path__ + "img/Inflammation-LICA_GSE236681.a41fb60e.png";